// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { Dialog, Stack, Typography } from '@mui/material';
import ContainedButton from 'src/components/buttons/ContainedButton';
import useApp from 'src/hooks/useApp';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import ScrollToTop from './components/ScrollToTop';

// ----------------------------------------------------------------------

export default function App() {
  const {
    showSessionExpiredModal,
    setShowSessionExpiredModal
  } = useApp()

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <NotistackProvider>
          {/* <ThemeSettings> */}
          <ProgressBarStyle />
          <ScrollToTop />
          <Router />
          <Dialog open={showSessionExpiredModal} onClose={() => setShowSessionExpiredModal(false)}>
            <Stack p={2} spacing={2}>
              <Typography variant='h6' >
                Sua sessão expirou por inatividade. Faça login novamente.
              </Typography>
              <ContainedButton title='Fechar' onClick={() => setShowSessionExpiredModal(false)} />
            </Stack>
          </Dialog>
          {/* </ThemeSettings> */}
        </NotistackProvider>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
